export default __webpack_public_path__ + "689e6e587a2dc8aefa9be351e4341e62.png";